<svg
  width="18px"
  height="18px"
  viewBox="0 0 18 18"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="web/fields/search-bar" transform="translate(-12, -11)">
      <g id="web/icon/search" transform="translate(12, 11)">
        <rect id="Rectangle" x="0" y="0" width="18" height="18"></rect>
        <g id="icons/search" transform="translate(1, 1)" stroke="#000000" stroke-width="2">
          <circle id="Oval" cx="6" cy="6" r="6"></circle>
          <path d="M6,3 C4.34314575,3 3,4.34314575 3,6" id="Path" stroke-linecap="round"></path>
        </g>
        <line
          x1="11.5"
          y1="11.5"
          x2="17"
          y2="17"
          id="Path-4"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
        ></line>
      </g>
    </g>
  </g>
</svg>
